module.exports = __webpack_public_path__ + "img/guitar-electric.8fbb74f0.svg";